export const GOALS_LANDING_PAGE = '/.*\\/dashboard$';
export const REVIEW_CREATE_PATH = '/review/create';
export const REVIEW_WRITE_PATH = '/review/write';
export const REVIEW_CALIBRATION_PATH = '/review/.*/calibrate';
export const REVIEW_VIEW_PATH = '/review/view';
export const REVIEW_EMPLOYEE_VIEW_PATH = '/review/.*/employee-view';
export const REVIEW_TEAM_REVIEW_PATH = '/review/.*/team-review';
export const REVIEW_MANAGE_PATH = '/review/dashboard/manage';
export const FEEDBACK_GIVE_PATH = '/feedback/give-feedback';
export const FEEDBACK_REQUEST_PATH = '/feedback/request-feedback';
export const FEEDBACK_REQUESTED_PATH = '/feedback/dashboard/requested';

// Default inclusion list using the constants
const DEFAULT_URL_INCLUSION_LIST = [
  { pattern: new RegExp(REVIEW_CREATE_PATH) },
  { pattern: new RegExp(REVIEW_WRITE_PATH) },
  { pattern: new RegExp(REVIEW_CALIBRATION_PATH) },
  { pattern: new RegExp(REVIEW_VIEW_PATH) },
  { pattern: new RegExp(REVIEW_EMPLOYEE_VIEW_PATH) },
  { pattern: new RegExp(REVIEW_TEAM_REVIEW_PATH) },
  { pattern: new RegExp(REVIEW_MANAGE_PATH) },
  { pattern: new RegExp(FEEDBACK_GIVE_PATH) },
  { pattern: new RegExp(FEEDBACK_REQUEST_PATH) },
  { pattern: new RegExp(FEEDBACK_REQUESTED_PATH) },
  { pattern: new RegExp(GOALS_LANDING_PAGE) }
];

export const getInclusionListFromConfig = cuesFeatureConfig => {
  const configList = cuesFeatureConfig?.analytics_enabled_paths?.paths;

  if (Array.isArray(configList) && configList.length > 0) {
    try {
      return configList
        .filter(item => item?.enabled && item?.pattern)
        .map(item => {
          try {
            return { pattern: new RegExp(item.pattern) };
          } catch (e) {
            console.error(`Invalid regex for pattern: ${item.pattern}`, e);
            return null;
          }
        })
        .filter(item => item !== null);
    } catch (e) {
      console.error('Error processing analytics_inclusion_list:', e);
    }
  }
  return DEFAULT_URL_INCLUSION_LIST;
};

export const shouldTrackPath = (path, cuesFeatureConfig) => {
  const inclusionList = getInclusionListFromConfig(cuesFeatureConfig);
  return inclusionList.some(rule => rule.pattern.test(path));
};
